(function () {

  function bindCalculator() {

    const input = document.querySelector('#zip-calc-input');
    const button = document.querySelector('#zip-calc-submit');

    if (!input || !button || !window.SHIPPING_CALCULATOR_CONFIG) {
      return false;
    }

    if (button.dataset.bound === 'true') {
      return true;
    }

    const errorBox = document.querySelector('.shipping-box .error');
    const resultBox = document.querySelector('.zip-result');
    const cfg = window.SHIPPING_CALCULATOR_CONFIG;

    console.log('Shipping calculator bound');

    button.dataset.bound = 'true';

    button.addEventListener('click', function () {

      console.log('Submit clicked');

      const zip = input.value.trim();
      if (!zip) {
        errorBox.textContent = 'Bitte geben Sie eine PLZ ein';
        return;
      }

      errorBox.textContent = '';
      resultBox.style.display = 'none';
      button.disabled = true;

      const qty =
        parseInt(document.querySelector('input[name="quantity"]')?.value) || 1;

      const formData = new FormData();
      formData.append('shop', cfg.shop);
      formData.append('rate[destination][postal_code]', zip);
      formData.append('rate[items][0][quantity]', qty);
      formData.append('rate[items][0][price]', cfg.productPrice);
      formData.append('rate[items][0][grams]', cfg.productWeight);

      fetch('https://sbz.cirkleinc.com/front-widget', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(data => {

        if (!data?.rates?.[0]?.total_price) {
          errorBox.textContent = 'Die Region mit der angegebenen PLZ wird nicht abgedeckt';
          button.disabled = false;
          return;
        }

        const shipping = data.rates[0].total_price;
        const subtotal = cfg.productPrice * qty;

        let supp = 0;
        if (cfg.rollrasenPerM2) {
          supp = Math.ceil(qty / cfg.rollrasenPerM2) * cfg.suppProductPrice;
          document.querySelector('.zip-supp-product-result .result-number').textContent =
            Math.ceil(qty / cfg.rollrasenPerM2);
          document.querySelector('.zip-supp-product-result .result-value').textContent =
            Shopify.formatMoney(supp, cfg.moneyFormat);
        }

        const total = subtotal + shipping + supp;
        const unit = total / qty;

        document.querySelector('.zip-calc-result .result-value').innerHTML =
          Shopify.formatMoney(shipping, cfg.moneyFormat) +
          ' Lieferkosten nach ' + zip;

        document.querySelector('.combined-value .result-value').textContent =
          Shopify.formatMoney(total, cfg.moneyFormat);

        document.querySelector('.combined-value .unit-price').textContent =
          cfg.rollrasenPerM2
            ? '(' + Shopify.formatMoney(unit, cfg.moneyFormat) + ' pro m²)'
            : '';

        resultBox.style.display = 'block';
        button.disabled = false;
      })
      .catch(err => {
        console.error(err);
        errorBox.textContent = 'Calculation error';
        button.disabled = false;
      });
    });

    return true;
  }

  // 🔁 KEEP TRYING UNTIL FLUX RENDERS THE SECTION
  function waitForCalculator() {
    if (!bindCalculator()) {
      setTimeout(waitForCalculator, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', waitForCalculator);
  document.addEventListener('shopify:section:load', waitForCalculator);

})();
